import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import {
  Facebook, Twitter, Instagram, Youtube,
} from './SocialMediaIcons';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
  },
  list: {
    marginTop: theme.typography.pxToRem(7),
    marginBottom: theme.typography.pxToRem(25),
  },
  listItem: {
    width: 'auto',
    display: 'inline-flex',
    marginRight: theme.typography.pxToRem(14),
  },
  listIcon: {
    minWidth: theme.typography.pxToRem(40),
    width: theme.typography.pxToRem(40),
    height: theme.typography.pxToRem(40),
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid #797979',
    borderRadius: '50%',
    "& [class*='MuiSvgIcon-root']": {
      color: theme.palette.grey['50'],
    },
  },
}));

const socialLinks = [
  {
    href: 'https://www.facebook.com/EagleShare/',
    icon: <Facebook />,
  },
  // {
  //   href: 'https://twitter.com/EagleShare',
  //   icon: <Twitter viewBox="-3 -3 24 24" />,
  // },
  {
    href: 'https://www.instagram.com/eagleshare/',
    icon: <Instagram />,
  },
  {
    href: 'https://www.youtube.com/channel/UCeXLBDmQ90I10UQkcMMhNQQ',
    icon: <Youtube />,
  },
];

const FollowUs = ({ title }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      <List component="div" className={classes.list}>
        {socialLinks.map((link) => (
          <ListItem
            key={link.href}
            dense
            className={classes.listItem}
            href={link.href}
            rel="noopener"
            target="_blank"
            component="a"
            disableGutters
          >
            <ListItemIcon className={classes.listIcon}>
              {link.icon}
            </ListItemIcon>
          </ListItem>
        ))}
      </List>
      <Divider />
    </div>
  );
};

export default FollowUs;
